import axios from 'axios';
import isJsonStr from "../utils/modules/isJsonStr";

//下载模板
function Api_downFile(dwzh, ywlx, qflx = null) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/file/bpmbxz', {}, {
            data: {
                para: {
                    'jydm': "9001",
                    "qqly": 2,
                    "yhlx": 1,
                    'extParam': {
                        'dwzh': dwzh,
                        'qflx': qflx,
                        'ywlx': ywlx
                    }
                }
            }
        })
            .then(res => {
                let data = res.data;
                if (data.code === '0000000') {
                    resolve(data);
                } else {
                    reject(res.data)
                }
            })
    });
}

//上传模板
function Api_uploadFile(dwzh, ywlx = '209', file, qflx = null) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/file/bpmbsc',
            {
                para: {
                    'jydm': "9002",
                    "qqly": 2,
                    "yhlx": 1,
                    'extParam': {
                        'dwzh': dwzh,
                        'ywlx': ywlx,
                        'qflx': qflx,
                        'file': {
                            'fileName': file.fileName,
                            'upperCase': file.upperCase,
                            'file': file.file
                        }
                    }
                }
            }).then(res => {
            let data = res.data;
            if (data.code === '0000000') {
                resolve(data);
            } else {
                reject(res.data)
            }
        })
    });
}

// 上传签章pdf文件
function Api_upPdfBsFile(formData) {
    return new Promise((resolve, reject) => {
        axios.post('/api/pdfFile', formData)
            .then(res => {
                    let data = res.data;
                    if (data.code === '0000000') {
                        resolve(data);
                    } else {
                        reject(data)
                    }
                }
            )
    });
}

/**
 * 获取上传材料列表
 * @param from
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_GetMaterial(from) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywcx/cllb',
            {
                para: {
                    jydm: "GetMaterial",
                    extParam: {...from}
                }
            }).then(res => resolve(res)).catch(error => reject(error))
    });
}

/**
 * 获取上传材料列表
 * @param from
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_GetMaterialFn(from) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywcx/cllb',
            {
                para: {
                    jydm: "GetMaterial",
                    extParam: {...from}
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    resolve(data.result)
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}

/**
 * 获取上传材料列表-自由职业者
 * @param from
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_GetMaterialFree(from) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywbl/freelancerRegister',
            {
                para: {
                    jydm: "GetMaterial",
                    extParam: {...from}
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    resolve(data.result)
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}


/**
 * 获取联行号
 * @param from
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_LianHangHao(from) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywcx/grdkxx',
            {
                para: {
                    "jydm": "LianHangHao",
                    "extParam": {
                        "yhzhid": "4",
                        "dyid": 201
                    }
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    resolve(data.result)
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}

/**
 * 获取联行号-自由职业者
 * @param from
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_LianHangHaoFree(from) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywbl/freelancerRegister',
            {
                para: {
                    "jydm": "LianHangHao",
                    "extParam": {
                        "yhzhid": "4",
                        "dyid": 201
                    }
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    resolve(data.result)
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}


/**
 * 获取枚举项目
 * @param gjz
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_mjcx(gjz) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywcx/mjcx',
            {
                para: {
                    jydm: 6003,
                    extParam: {gjz}
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    resolve(data.result[0][gjz])
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}


function Api_mjcxkfs(gjz) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywcx/mjcx',
            {
                para: {
                    jydm: 6003,
                    extParam: {gjz}
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    resolve(data.result[0])
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}

/**
 * 获取枚举项目-自由职业
 * @param gjz
 * @param key
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_mjcxFree(gjz, key) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywbl/freelancerRegister',
            {
                para: {
                    jydm: 6003,
                    extParam: {gjz}
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    const k = key ? key : gjz
                    resolve(data.result[0][k])
                    console.log(data.result,data.result[0][key],'数据打印')
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}

// 枚举查询开发商
function Api_mjcxFreeKfs(gjz, key) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywcx/noLoginkfsInfo',
            {
                para: {
                    jydm: 6003,
                    extParam: {gjz}
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    resolve(data.result[0])
                    console.log(data.result,data.result[0][key],'数据打印')
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}


/**
 * 查询分管银行列表
 * @param organId
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_FreelancerCust(organId) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywbl/freelancerRegister',
            {
                para: {
                    jydm: 'FreelancerCust',
                    qqly: 2,
                    extParam: {organId}
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    try {
                        resolve(data.result.custList.map(item => {
                            return {
                                ...item,
                                code: item.dwzh,
                                name: item.dwmc
                            }
                        }))
                    } catch (e) {
                        throw new Error('获取缴款银行失败')
                    }
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}


/**
 * 提交自由职业者开户
 * @param extParam
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_freelancerRegister(extParam) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywbl/freelancerRegister',
            {
                para: {
                    jydm: 'FreelancerRegister',
                    qqly: 2,
                    extParam
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    debugger
                    resolve(data.result)
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.result.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}

function Api_kfsRegister(extParam) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywbl/kfsRegister',
            {
                para: {
                    jydm: 'developerRegister',
                    qqly: 2,
                    extParam
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    debugger
                    resolve(data)
                    console.log(data,'data打印')
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.result.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}







/**
 * 自由职业者开户进度查询
 * @param extParam
 * @returns {Promise<unknown>}
 * @constructor
 */
function Api_freelancerStep(extParam) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywcx/freelancerStep',
            {
                para: {
                    jydm: 'FreelancerStep',
                    yhlx: 2,
                    qqly: 2,
                    extParam
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                if (data.status === '0') {
                    debugger
                    resolve(data.result)
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.result.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}


function Api_KaifashangStep(extParam) {
    return new Promise((resolve, reject) => {
        axios.post('/ej-isp-api/zk/ywcx/kfsStep',
            {
                para: {
                    jydm: 'developerStep',
                    yhlx: 2,
                    qqly: 2,
                    extParam
                }
            }).then(({data: res}) => {
            if (res.code === '0000000' && isJsonStr(res.body)) {
                const data = JSON.parse(res.body)
                console.log(data,'data打印')
                if (data.status === '0') {
                    debugger
                    resolve(data.result)
                } else {
                    throw {message: data.msg.map(item => item.cwxx).join('<br>') || data.result.message}
                }
            } else {
                throw res
            }
        }).catch(error => reject(error))
    });
}


export {
    Api_KaifashangStep,
    Api_downFile,
    Api_uploadFile,
    Api_upPdfBsFile,
    Api_GetMaterial,
    Api_GetMaterialFn,
    Api_LianHangHao,
    Api_mjcx,
    Api_LianHangHaoFree,
    Api_GetMaterialFree,
    Api_mjcxFree,
    Api_FreelancerCust,
    Api_freelancerRegister,
    Api_freelancerStep,
    Api_kfsRegister,
    Api_mjcxkfs,
    Api_mjcxFreeKfs
};



// WEBPACK FOOTER //
// ./src/static/js/api/downFile.js